// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientDashboard_custom1-scrollbar__qTwu6 {
  overflow-x: auto; /* Enable horizontal scrolling */
  scrollbar-width: none; /* Hide scrollbar in Firefox */
  -ms-overflow-style: none; /* Hide scrollbar in IE/Edge */
}

.clientDashboard_custom1-scrollbar__qTwu6::-webkit-scrollbar {
  display: none; /* Hide scrollbar in Chrome, Safari, Edge */
}
`, "",{"version":3,"sources":["webpack://./src/styles/clientDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,qBAAqB,EAAE,8BAA8B;EACrD,wBAAwB,EAAE,8BAA8B;AAC1D;;AAEA;EACE,aAAa,EAAE,2CAA2C;AAC5D","sourcesContent":[".custom1-scrollbar {\n  overflow-x: auto; /* Enable horizontal scrolling */\n  scrollbar-width: none; /* Hide scrollbar in Firefox */\n  -ms-overflow-style: none; /* Hide scrollbar in IE/Edge */\n}\n\n.custom1-scrollbar::-webkit-scrollbar {\n  display: none; /* Hide scrollbar in Chrome, Safari, Edge */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom1-scrollbar": `clientDashboard_custom1-scrollbar__qTwu6`
};
export default ___CSS_LOADER_EXPORT___;
